<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增问卷
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词"
            />
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="queryForm.step" placeholder="状态" clearable>
              <el-option
                v-for="item in stepOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
            <el-button icon="el-icon-download" type="warning" :loading="exportLoading" @click="exportData">
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="适用身份"
        prop="basic.roleList"
        width="300"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        width="500"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag>{{ formatTypehood(row) }}</el-tag> {{ row.title }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="展示次数"
        prop="basic.totalVisitCount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="回复次数"
        prop="basic.totalRecordCount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="状态"
        prop="step"
        show-overflow-tooltip
        >
        <template #default="{ row }">
          <el-tag v-if="row.step === 1">待发布</el-tag>
          <el-tag v-if="row.step === 2" type="success">已发布</el-tag>
          <el-tag v-if="row.step === 3" type="danger">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建时间"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
                <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleRecord(row)">
            记录
          </el-button>
          <el-button type="text" class="mr-10" @click="handleShow(row)">
            详情
          </el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-if="row.step === 1" :command="{ cmd: 'publish', item: row }">
                  发布
                </el-dropdown-item>
                <el-dropdown-item v-if="row.step === 2" :command="{ cmd: 'close', item: row }">
                  下架
                </el-dropdown-item>
                <el-dropdown-item v-if="row.step === 1" :command="{ cmd: 'edit', item: row }">
                  修改
                </el-dropdown-item>
                <el-dropdown-item v-if="row.step != 2" :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <detail ref="show" />
    <record ref="record" />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import typehoods from './typehood.config'
import { findQuestList, updateQuest, removeQuest, exportQuest, } from '@/api/alfmeier'
import Edit from './edit.vue'
import Detail from './detail.vue'
import Record from './record.vue'
export default {
  name: 'AlfmeierQuestList',
  components: { Edit, Detail, Record },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      exportLoading: false,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      stepOptions: [
        {
          label: '待发布',
          value: 1,
        }, {
          label: '已发布',
          value: 2,
        }, {
          label: '已下架',
          value: 3,
        }
      ],
      queryForm: {
        page: 1,
        size: 10,
        startTime: '',
        endTime: '',
        keyword: '',
        step: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/alfmeier/questList') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    formatTypehood(row) {
      const find = typehoods.find(e => e.value == row.typehood)
      return find && find.label || '未知'
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    handleRecord(row) {
      this.$refs['record'].showRecord(row)
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handlePublish(row) {
      this.$baseConfirm(`你确定要发布问卷：${row.title} 吗`, null, async () => {
        await updateQuest({ questId: row.questId, step: 2 })
        this.$baseMessage(
          `发布问卷成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.fetchData()
      })
    },
    handleClose(row) {
      this.$baseConfirm(`你确定要下架问卷：${row.title} 吗`, null, async () => {
        await updateQuest({ questId: row.questId, step: 3 })
        this.$baseMessage(
          `下架问卷成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.fetchData()
      })
    },
    handleDelete(row) {
      this.$baseConfirm(`你确定要删除问卷：${row.title} 吗`, null, async () => {
        await removeQuest({ questId: row.questId })
        this.$baseMessage(
          `删除问卷成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.fetchData()
      })
    },
    handleCommand(command) {
      switch (command.cmd) {
        case 'publish':
          this.handlePublish(command.item)
          break
        case 'close':
          this.handleClose(command.item)
          break
        case 'edit':
          this.handleEdit(command.item)
          break
        case 'delete':
          this.handleDelete(command.item)
          break
      }
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async exportData() {
      this.exportLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const ret = await exportQuest(data)
      this.exportLoading = false
      if(ret && ret.url){
        this.$alert(`下载地址：${ret.url}`, '问卷导出', {
          confirmButtonText: '立即下载',
          callback: action => {
            window.location.href = ret.url
          }
        })
      }
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findQuestList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
